import { render, staticRenderFns } from "./paypwd.vue?vue&type=template&id=30c42d0d&"
import script from "./paypwd.vue?vue&type=script&lang=js&"
export * from "./paypwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports